<template>
    <c-modal @close="close" :title="'Vertaling afkeuren'">
        <p>Laat hier weten waarom zijn/haar dienst is afgekeurd.</p>

        <c-form ref="form" :autocomplete="'off'" @valid="submit">
            <c-form-element
                :label="'Opmerking'"
                :horizontal="true">
                <textarea name="remark" required="true" v-model="remark"></textarea>
            </c-form-element>

            <div class="c-modal__btn">
                <input type="submit" class="c-btn c-btn--secondary no-margin" value="Versturen"/>
            </div>
        </c-form>
    </c-modal>
</template>

<script>

import CModal from '@components/Modal';
import Form from '@mixins/Form';

export default {
    components: { CModal },
    mixins: [ Form ],
    data() {
        return {
            remark: ''
        }
    },
    methods: {
        close() {

            this.$refs.form.reset();
            this.remark = '';
            this.$emit('close');
        },
        submit() {            
            this.$emit('submit', this.remark);
        }
    }
}
</script>
